"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Placement = require("./utils/Placement");

var _Use = require("./utils/Use");

var _PlacementConstants = require("./PlacementConstants");

var _Styles = require("../utils/Styles");

var _colors = require("HubStyleTokens/colors");

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  pointer-events: none;\n\n  border: ", ";\n\n  /* Hide the half of the arrow rect that's positioned inside of the popover */\n  clip-path: polygon(100% 100%, 0 100%, 100% 0);\n\n  /* In IE11, clip-path won't work, so we settle for just making the inside part smaller */\n  border-top-left-radius: 100%;\n  border-top-color: transparent !important;\n  border-left-color: transparent !important;\n\n  /* Apply a bit of rounding to the pointy part of the arrow */\n  border-bottom-right-radius: ", ";\n\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        left: ", "px;\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        left: calc(50% - ", "px);\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        right: ", "px;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        top: ", "px;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        top: calc(50% - ", "px);\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        bottom: ", "px;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        transform: rotate(-45deg);\n        left: calc(100% - ", "px);\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        transform: rotate(-135deg);\n        top: -", "px;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        transform: rotate(135deg);\n        left: -", "px;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        transform: rotate(45deg);\n        top: calc(100% - ", "px);\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var mediumArrowSize = 16;
var smallArrowSize = 12;

var isShepherdArrowWhite = function isShepherdArrowWhite(placement) {
  return (0, _Placement.getSide)(placement) !== 'bottom' && (0, _Placement.getEdge)(placement) !== 'bottom';
};

var getBackgroundColor = function getBackgroundColor(_ref) {
  var color = _ref.color,
      placement = _ref.placement,
      popoverUse = _ref.popoverUse;

  if (color) {
    return color;
  }

  if (popoverUse === 'shepherd') {
    return isShepherdArrowWhite(placement) ? _colors.OLAF : _colors.THUNDERDOME;
  }

  return 'inherit';
};

var getSideStyles = function getSideStyles(_ref2) {
  var placement = _ref2.placement,
      width = _ref2.width;

  switch ((0, _Placement.getSide)(placement)) {
    case 'top':
      // Arrow points down
      return (0, _styledComponents.css)(_templateObject(), width / 2);

    case 'right':
      // Arrow points left
      return (0, _styledComponents.css)(_templateObject2(), width / 2);

    case 'bottom':
      // Arrow points up
      return (0, _styledComponents.css)(_templateObject3(), width / 2);

    case 'left':
      // Arrow points right
      return (0, _styledComponents.css)(_templateObject4(), width / 2);

    default:
      return '';
  }
};

var getEdgeStyles = function getEdgeStyles(_ref3) {
  var inset = _ref3.inset,
      placement = _ref3.placement,
      width = _ref3.width;
  // Magic calculation, haven't quite figured this out yet
  var adjustedInset = inset + 3;

  switch ((0, _Placement.getEdge)(placement)) {
    case 'top':
      // Arrow is near the bottom of the left or right side
      return (0, _styledComponents.css)(_templateObject5(), adjustedInset);

    case 'middle':
      return (0, _styledComponents.css)(_templateObject6(), width / 2);

    case 'bottom':
      // Arrow is near the top of the left or right side
      return (0, _styledComponents.css)(_templateObject7(), adjustedInset);

    case 'left':
      // Arrow is near the right of the top or bottom side
      return (0, _styledComponents.css)(_templateObject8(), adjustedInset);

    case 'center':
      return (0, _styledComponents.css)(_templateObject9(), width / 2);

    case 'right':
      // Arrow is near the left of the top or bottom side
      return (0, _styledComponents.css)(_templateObject10(), adjustedInset);

    default:
      return '';
  }
};

var getBorderUseStyles = function getBorderUseStyles(_ref4) {
  var placement = _ref4.placement,
      popoverUse = _ref4.popoverUse;

  if (popoverUse === 'default' || popoverUse === 'longform' || popoverUse === 'shepherd' && isShepherdArrowWhite(placement)) {
    return "1px solid " + _colors.BATTLESHIP;
  }

  return null;
};

var Arrow = _styledComponents.default.div.withConfig({
  displayName: "UIPopoverArrow__Arrow",
  componentId: "sc-1xqy3zq-0"
})(_templateObject11(), getBorderUseStyles, function (_ref5) {
  var popoverUse = _ref5.popoverUse;
  return popoverUse.includes('tooltip') ? '3px' : null;
}, function (_ref6) {
  var width = _ref6.width;
  return (0, _Styles.toPx)(width);
}, function (_ref7) {
  var width = _ref7.width;
  return (0, _Styles.toPx)(width);
}, getBackgroundColor, getSideStyles, getEdgeStyles);

var UIPopoverArrow = _react.default.memo(function (_ref8) {
  var className = _ref8.className,
      width = _ref8.width,
      rest = (0, _objectWithoutProperties2.default)(_ref8, ["className", "width"]);
  return width === 0 ? null : _react.default.createElement(Arrow, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('uiPopoverArrow private-popover__arrow', className),
    width: width
  }));
});

if (process.env.NODE_ENV !== 'production') {
  UIPopoverArrow.propTypes = {
    color: _propTypes.default.string,
    inset: _propTypes.default.number.isRequired,
    placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    popoverUse: _propTypes.default.oneOf(Object.keys(_Use.USE_CLASSES)),
    width: _propTypes.default.number
  };
}

UIPopoverArrow.defaultProps = {
  inset: 0,
  placement: 'top',
  width: 20
};
UIPopoverArrow.ARROW_SIZES = {
  none: {
    distance: 4,
    inset: 0,
    width: 0
  },
  medium: {
    distance: mediumArrowSize,
    inset: mediumArrowSize - 2,
    width: 20
  },
  small: {
    distance: smallArrowSize,
    inset: smallArrowSize - 2,
    width: 16
  }
};
UIPopoverArrow.displayName = 'UIPopoverArrow';
var _default = UIPopoverArrow;
exports.default = _default;
module.exports = exports.default;